import { ModuleWithProviders } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { AuthGuard } from "@atenea-cms";
import { FilterListComponent } from "./filter-list/filter-list.component";
import { FilterFormComponent } from "./filter-form/filter-form.component";

const routes: Routes = [
  {
    path: "filters",
    component: FilterListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "filters/new",
    component: FilterFormComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "filters/:id",
    component: FilterFormComponent,
    canActivate: [AuthGuard],
  },
];

export const FiltersRoutes: ModuleWithProviders = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/filters/filters.routes.ts